/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetadataDm } from '../../models/metadata-dm';

export interface DeleteAttribute$Params {
  orid?: number;
      body: MetadataDm
}

export function deleteAttribute(http: HttpClient, rootUrl: string, params: DeleteAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<MetadataDm>> {
  const rb = new RequestBuilder(rootUrl, deleteAttribute.PATH, 'delete');
  if (params) {
    rb.query('orid', params.orid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MetadataDm>;
    })
  );
}

deleteAttribute.PATH = '/api/MetaModel';
